import {Vec3} from "../../../../../Utils/ThreeJS/VectorStructs.js";
import {StandardMeshFix} from "../../Utils/ModelProcessor.js";
import {useSimple3DComp} from "../Hooks.js";
import {LHQInstance} from "../Scene.js";

// room boundaries
// ==========

export const LHQFloor = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Floor_1.0.glb",
	textureRescaling: 1,
	/*extraProcessing_early: mesh=>{
		mesh.material["map"] = null;
	},*/
	extraProcessing_mid: mesh=>{
		mesh.castShadow = false;

		// for testing: artifically add tiling
		/*mesh["partOfFloor"] = true;
		const origUVs = mesh.geometry.attributes.uv.clone();
		const uvs = mesh.geometry.attributes.uv;
		// scale all the UVs by X (to make them tile, as test)
		for (let i = 0; i < uvs.count; i++) {
			uvs.setXY(i, uvs.getX(i) * 8, uvs.getY(i) * 8);
		}
		uvs.needsUpdate = true; // mark the UVs as needing an update*/
	},
});
export const LHQWalls = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Walls_1.0.glb",
	textureRescaling: .2,
});
export const LHQCeiling = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Ceiling_1.0.glb",
	textureRescaling: .2,
});

// wall contents
// ==========

export const LHQDoors = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Doors_1.0.glb",
	textureRescaling: .2,
});
export const LHQWindows = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Windows_1.0.glb",
	textureRescaling: .2,
	castShadows: false,
	allowMaterialChanging: false, // window materials become all black (for some reason) if we allow material-changing
});
export const LHQPainting = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Painting_1.0.glb",
	textureRescaling: .2,
});

// room contents
// ==========

export const LHQSofaSet = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/SofaSet_3.2.glb",
	position: new Vec3(.5, 1 - 2, 0),
	extraProcessing_late: mesh=>{
		StandardMeshFix(mesh);
	},
});
export const LHQDesksAndGlassWalls = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/DesksAndGlassWalls_3.1.glb",
	textureRescaling: .2,
});
export const LHQConferenceTable = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/ConferenceTable_2.0.glb",
	textureRescaling: .2,
});
export const LHQElectronics = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Electronics_2.0.glb",
	textureRescaling: .2,
	nodeProcessing_extraFilter: node=>node.name != "CoffeeMaker",
});
export const LHQBookshelves = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Bookshelves_1.0.glb",
	textureRescaling: .2,
});

// hall
// ==========

// balcony
// ==========

export const LHQBalcony = ({lhq}: {lhq: LHQInstance})=>useSimple3DComp(lhq, {
	path: "/3D/ZUp/Balcony_1.0.glb",
	textureRescaling: .2,
});